import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import config from '../../configuration/config';
import { useHistory } from "react-router";
import ConfirmContext from "../../utils/confirmContext";
import _ from 'lodash';
import Popup from "../../User/popup";
import { getData } from "../../utils/localStorageManager";


export function SparePartsReservationCheckPage({ ...props }) {
    const history = useHistory();
    const thisConfirmContext = useContext(ConfirmContext);
    const { orderGuid } = useParams();
    const location = useLocation();
    const { t: trans, i18n } = useTranslation(["new", "finance", "cartFile", "info", "new"]);


    let lang = (i18n.language || 'ar');
    const [showFinalPopupMessage, setShowFinalPopupMessage] = useState("");

    const [sadadInfo, setSadadInfo] = useState(null);
    const [dataFinalPopup, setDataFinalPopup] = useState({});
    const [dataOrderDraft, setDataOrderDraft] = useState({});
    const [showStstusLodingPopup, setShowStstusLodingPopup] = useState(false);
    const [showFinalPopup, setShowFinalPopup] = useState(false);

    useEffect(() => {

        fetchOrderDraftPaymentStatus();
    }, []);


    useEffect(() => {

    }, []);




    const fetchOrderDraftPaymentStatus = async () => {

        var OrderGUID = orderGuid?.trim();
        if (!OrderGUID) return;
        const paymentStatus = new URL(window.location.href).searchParams.get("paymentStatus");
        const paymentMethodCallback = new URL(window.location.href).searchParams.get("PaymentMethod");
        const paymentTypeCallback = new URL(window.location.href).searchParams.get("PaymentType");
        setShowStstusLodingPopup(true);
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var raw = {
                "paytype": paymentMethodCallback,
                "OrderGUID": OrderGUID,
            };

            const response = await axios.request({
                baseURL: config.controllURL,
                url: "api/Payment/SendAllPaymentStatus_SpareParts_Reservation",
                headers: myHeaders,
                data: raw, method: "POST", responseType: "json"
            });

            const responseData = response?.data;
            // const responseData = siteSalesOrderDraftResponse;

            setDataOrderDraft(responseData);
            setShowStstusLodingPopup(false);

            if (!responseData) {

                setShowFinalPopup(true);
                setShowFinalPopupMessage("بيانات الحجز و الدفع غير موجوده");
                return;
            }

            let data = Array.isArray(responseData)
                ? responseData[0]
                : responseData;

            console.log("data:", data);
            if (!data) {

                setShowFinalPopup(true);
                setShowFinalPopupMessage("بيانات الحجز و الدفع غير موجوده");
                return;
            }
            console.log("data.Status:", data.Status);
            if (data.Status === "notPaid") {

                setShowFinalPopup(true);
                setShowFinalPopupMessage(trans("new:Payment_was_not_completed_Purchase_process_failed"));

                return;
            }


            if (data.Status === "success") {
                if (data?.SadadNumber) setSadadInfo(data.SadadNumber);
                setShowFinalPopup(true);
                setShowFinalPopupMessage(trans("new:payment_success"));
                setDataFinalPopup(data);
            } else if (data?.ResponseText) {
                try {
                    const jsonData = JSON.parse(data.ResponseText);
                    // console.log("IsSuccess:", jsonData.IsSuccess);
                    // console.log("InvoiceStatus:", jsonData.Data?.InvoiceStatus);

                    if (jsonData.IsSuccess == true && jsonData.Data?.InvoiceStatus) {
                        setShowFinalPopup(true);
                        // setShowFinalPopupMessage(data?.Message);
                        setShowFinalPopupMessage(trans("يرجاء التاكد من عملية الدفع , يبدو انها لم تتم او قد تحتاج تاكيد من المسوؤل  "));
                        data["InvoiceStatus"] = jsonData.Data?.InvoiceStatus;
                        setDataFinalPopup(data);
                    }
                } catch (error) {
                    console.error("Invalid JSON:", error);
                }

            } else if (data?.Message) {
                setShowFinalPopup(true);
                setShowFinalPopupMessage(data?.Message);
                setDataFinalPopup(data);

            } else if (data?.ErrorMessage) {
                alert(`${data.ErrorMessage} / ${data?.ErrorProcedure || ""}`);
            }

        } catch (error) {
            console.error("Error fetching payment status:", error);
        }
    };

    return (
        <>

            <Popup show={showFinalPopup}>
                <div className="w-full  flex flex-column justify-center items-center" >
                    <div className="cart-finalized" >
                        <div className="cart-finalized-container flex flex-col">

                            <div className="cart-finalized-container-img flex flex-col">
                                <img src="/assets/images/finalized.svg" alt="" />
                            </div>

                            <div className="flex flex-wrap justify-center">
                                <span className="text-20 font-bold text-black mx-2 unselectable ">{trans("new:thank_to_choose")}</span>
                                <span className="text-20 font-bold text-primary mx-2"> {trans("new:HJ_cars")}</span>
                            </div>

                            {showFinalPopupMessage &&
                                <>
                                    <div className="flex mt-10 flex-wrap justify-center mx-20">
                                        <span className="text-24 text-gray  mx-2"> {showFinalPopupMessage}</span>
                                    </div>

                                </>

                            }
                            {dataFinalPopup?.InvoiceStatus &&
                                <>
                                    <div className="flex flex-wrap justify-center mx-20">
                                        {/* <span className="text-24 text-gray  mx-2"> {trans("new:payment_status") + ":"}</span> */}
                                        <span className="text-24 text-gray  mx-2"> {dataFinalPopup?.InvoiceStatus}</span>
                                    </div>

                                </>

                            }
                            {
                                dataFinalPopup &&
                                <>

                                    {
                                        dataFinalPopup?.OrderId &&
                                        <div className="flex flex-row justify-center cart-finalized-code"
                                            onClick={() => {

                                                navigator.clipboard.writeText(dataFinalPopup?.OrderId);
                                            }}

                                        >

                                            <span className="text-20 font-bold text-white  mx-2"> {trans("info:order-number") + " :"}</span>
                                            <span className="text-20 font-bold text-white  mx-2">{dataFinalPopup?.OrderId && dataFinalPopup?.OrderId}</span>
                                            <img src="/assets/icons/copy.svg" alt='' />
                                        </div>
                                    }
                                </>

                            }

                            {
                                sadadInfo &&
                                <>

                                    <div className="flex mt-10  flex-wrap justify-center mx-20">
                                        <span className="text-24 text-center text-gray  mx-2"> {trans("new:a_payment_number_has_already_been_created")
                                            + " " + trans("new:to_avoid_order_cancellation")
                                            + " " + trans("new:within_24_hours")}</span>
                                    </div>

                                    <div className="flex cart-finalized-code flex-row nice-align-item-center"
                                        onClick={() => {

                                            navigator.clipboard.writeText(sadadInfo);
                                        }}
                                    >
                                        <div className=" bg-white border-radius p-1 ">
                                            <img className=" object-contain" width={50} height={50}
                                                src={"/assets/icons/companies/SADAD-Logo.png"} alt={"SADAD"} />
                                        </div>
                                        {
                                            <div className="flex flex-row justify-center  mt-2">

                                                {/* <span className="text-20 font-bold text-white  mx-2"> {trans("new:sadad") + " :"}</span> */}
                                                <span className="text-20 font-bold text-white  mx-2">{sadadInfo}</span>

                                            </div>
                                        }
                                        <img src="/assets/icons/copy.svg" alt='' />
                                    </div>

                                </>

                            }



                            <div className="flex nice-flex-center  nice-align-item-center nice-flex-space-between w-100  gap-5 justify-items-auto 
                            py-10 px-20  my-20 ">

                                <div className="col-span-12 md:col-span-5 sm:col-span-5 lg:col-span-5 xl:col-span-5"></div>
                                <div className="col-span-12 md:col-span-5 sm:col-span-5 lg:col-span-5 xl:col-span-5">

                                    <div className={"btn nice-flex-row  py-5 px-5 text-white text-24 " + ((dataFinalPopup && dataFinalPopup?.OrderId && dataFinalPopup?.StatusPaymentID === "FullyPaid") ? " bg-primary " : " bg-gray ")}
                                        onClick={async () => {

                                            if (dataFinalPopup && dataFinalPopup?.OrderId && dataFinalPopup?.StatusPaymentID === "FullyPaid") {
                                                // You can await here
                                                const isLogin = getData('isAuthenticated');
                                                console.log("isLogin:", isLogin);
                                                if (isLogin) {
                                                    history.push({
                                                        pathname: `/SearchPage`,
                                                        // search: `orderDraftID=${orderGuid}`
                                                    });
                                                    //   history.push("/user/myOrders");
                                                } else {

                                                    // thisConfirmContext.onShowRegistrationPup(true,
                                                    //     `/SearchPage`);
                                                    history.push({
                                                        pathname: `/SearchPage`,
                                                        // search: `orderDraftID=${orderGuid}`
                                                    });
                                                }
                                            }

                                            history.push({
                                                pathname: `/SearchPage`,
                                                // search: `orderDraftID=${orderGuid}`
                                            });

                                        }}




                                    >{(dataFinalPopup && dataFinalPopup?.OrderId) ? trans("new:order_tracking") : trans("common:home")}
                                        <div className={" mx-2 " + (lang == "ar" ? " rotate-180 " : "")}>

                                            <svg xmlns="http://www.w3.org/2000/svg" height="15" width="20" viewBox="0 0 448 512" >
                                                <path fill="#ffffff" strokeWidth="2" d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" />
                                            </svg>

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </Popup>
            <Popup show={showStstusLodingPopup && !showFinalPopup}>
                <div className="w-full  flex flex-column justify-center items-center" >
                    <div className="cart-finalized" >
                        <div className=" flex flex-column justify-center items-center gap-5">

                            <div className=" flex flex-col gap-3">
                                <img src="/assets/Loding_new.svg" width={120} height={120} alt="Loding" />

                                <span className="text-20 font-bold  text-primary mx-2 unselectable ">{trans("new:thank_you_for_order")}</span>
                            </div>

                            <div className="flex flex-wrap flex-column justify-center">
                                {/* <span className="text-20 font-bold text-blackmx-2"> {trans("new:نقوم الآن بمعالجة الطلب،.")}</span> */}
                                <span className="text-20 font-bold text-blackmx-2"> {trans("new:order_number_soon")}</span>
                            </div>

                            {showFinalPopupMessage &&
                                <>
                                    <div className="flex mt-10 flex-wrap justify-center mx-20">
                                        <span className="text-24 text-gray  mx-2"> {showFinalPopupMessage}</span>
                                    </div>

                                </>

                            }

                        </div>

                    </div>
                </div>
            </Popup>
        </>
    );
}